import BuyerBrowsePortfolio from './BuyerBrowsePortfolio.page';

export default BuyerBrowsePortfolio;
